<script setup lang="ts">
import { mdiYoutube, mdiTwitter, mdiEmail } from '@mdi/js'
</script>

<template>
  <div
    id="register-news"
    class="follow-now-area text-center"
  >
    <div class="centered-area">
      <SignUpNow />

      <div class="mt-8" />

      <h2>最新情報を受け取りましょう</h2>
      <p>
        エンコーディアの世界に踏み出すことに迷っていますか？<br>
        そんなあなたも、まずフォローしましょう！
      </p>

      <v-container max-width="480">
        <v-row>
          <v-col cols="4">
            <v-btn
              variant="tonal"
              class="follow-button"
              width="180"
              :prepend-icon="mdiYoutube"
              stacked
              href="https://www.youtube.com/@samurai-apps"
              target="_blank"
            >
              YouTube
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn
              variant="tonal"
              class="follow-button"
              width="180"
              :prepend-icon="mdiTwitter"
              stacked
              href="https://x.com/samuraiapps"
            >
              X
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-dialog max-width="600">
              <template #activator="{ props }">
                <v-btn
                  v-bind="props"
                  variant="tonal"
                  class="follow-button"
                  width="180"
                  :prepend-icon="mdiEmail"
                  stacked
                >
                  メルマガ
                </v-btn>
              </template>
              <template #default="{ isActive }">
                <v-card
                  class="register-form"
                  title="メールマガジンの登録"
                >
                  <v-card-text>
                    <HubSpotForm />
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />

                    <v-btn
                      text="とじる"
                      @click="isActive.value = false"
                    />
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<style scoped>
/* Add text shadow to sign-in button to make it more visible */
.v-btn[to="/signin"] {
  text-shadow: 0 0 0.3em rgba(0, 0, 0, 0.9);
  font-weight: 600;
}

.follow-now-area {
  background-color: var(--landing-color-navy);
  color: var(--landing-color-parchment);

  padding: 32px 0;
}

.follow-button {
  width: 180px;

  padding: 0.5em 0.5em;

  background-color: #F1F8E9;
  color: var(--landing-color-navy);
}

.register-form {
  background-color: #f7f7f7;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.5);

  border-radius: var(--landing-radius);
  padding: 1em;
}

.centered-area {
  width: 100%;
  height: 100%;
  max-width: var(--landing-max-width);
  margin: auto;
  padding: var(--landing-gutter);
}

.centered-area h2 {
  font-size: var(--landing-h2-size);
  font-weight: 700;
  text-align: center;
  margin-top: 0;
  margin-bottom: 0.5em;
}

.centered-area p {
  margin-bottom: 0.5em;
}
</style>
